import { createSelector } from '@ngrx/store';
import { surveyCreationFeature } from '../survey-creation.feature';

const { selectAudience } = surveyCreationFeature;

export const selectSurveyId = createSelector(
  selectAudience,
  ({ surveyId }) => surveyId,
);

export const selectSurvey = createSelector(
  selectAudience,
  ({ survey }) => survey,
);

export const selectMetadataForm = createSelector(
  selectAudience,
  ({ metadata }) => metadata,
);

export const selectSurveyClickBalancing = createSelector(
  selectMetadataForm,
  ({ value }) => !!value?.clickBalancing,
);

export const selectQualificationsForm = createSelector(
  selectAudience,
  ({ qualifications }) => qualifications,
);

export const selectQuotasForm = createSelector(
  selectAudience,
  ({ quotas }) => quotas,
);

export const selectSurveyFormState = createSelector(
  selectMetadataForm,
  selectQualificationsForm,
  selectQuotasForm,
  (metadata, qualifications, quotas) => ({ metadata, qualifications, quotas }),
);

/** The applied Feasibility filters (exclusions/inclusions) */
export const selectAdvancedFeasibilityFilters = createSelector(
  selectAudience,
  ({ advancedFeasibilityFilters }) => advancedFeasibilityFilters,
);

export const selectError = createSelector(selectAudience, ({ error }) => error);

export const selectLocationFileUpload = createSelector(
  selectAudience,
  ({ locationFileUpload }) => locationFileUpload,
);

export const selectLinkedTagIds = createSelector(
  selectAudience,
  ({ tagLinks }) => tagLinks.linkedTagIds,
);

export const selectLinkTagsError = createSelector(
  selectAudience,
  ({ tagLinks }) => tagLinks.linkTagsError,
);

export const selectSuppliersMetaDataBlendId = createSelector(
  selectAudience,
  ({ suppliersMetaData }) => suppliersMetaData.blendId,
);

export const selectIsDirty = createSelector(
  selectAudience,
  ({ metadata, qualifications, quotas }) =>
    metadata.isDirty || qualifications.isDirty || quotas.isDirty,
);
